import queryString from 'query-string';
export const parse = queryString.parse;
export const stringify = queryString.stringify;
//# sourceMappingURL=queryString.js.map